<template>
    <section id="login">
        <h1>Login for Teachers</h1>
        <form @submit="onSubmit">
            <b-field label=""
                type="is-warning"
                message="Please enter a valid email">
                <b-input type="email" name="email" v-model="input.email" placeholder="E-mail"></b-input>
            </b-field>
            <b-field label=""
                type="is-warning"
                message="Please enter your password">
                <b-input type="password" name="password" v-model="input.password" placeholder="Password"></b-input>
            </b-field>

            <!--<input type="text" name="username" v-model="input.username" placeholder="Username" />
            <input type="password" name="password" v-model="input.password" placeholder="Password" />-->
            <b-field :message="errors"
                type="is-danger"
                name="errors"
                >
                <!--<button type="button" v-on:click="login()" class="button">Login</button>-->
                <button type="submit" class="button">Login</button>
            </b-field>
        </form>
    </section>
</template>

<script>

    import axios from 'axios'

    export default {
        name: 'login',
        data () {
            return {
                input: {
                    email: "",
                    password: ""
                },
                result : "",
                errors: []
            }
        },
        methods: {
            onSubmit (evt) {
                evt.preventDefault()
                if(this.input.email != "" && this.input.password != "") {

                    axios.post('http://localhost:8081/api/auth/teacher/login', this.input)
                    .then(response => {
                        console.log('imin 1')
                        localStorage.setItem('user',JSON.stringify(response.data.user))
                        localStorage.setItem('jwtToken', response.data.token)
                        localStorage.setItem('email',this.input.email)
                        localStorage.setItem('sessionID', response.data.sessionID)                        
                        console.log('imin 2')
                        if (localStorage.getItem('jwtToken') != null){     
                            
                            this.$emit("authenticated", true)
                            console.log('imin 3')
                            this.$emit('loggedIn')                
                            console.log('imin 4')
                            if(this.$route.params.nextUrl != null){         
                                console.log('imin 5')
                                this.$router.push(this.$route.params.nextUrl)         
                            console.log('imin 6')
                            }
                            else {         
                            console.log('imin 7')
                                    this.$router.push('/teacher/launchpad')
                            console.log('imin 8')
                                
                            }
                        }



                        // this.$router.push({
                        //     name: 'secure'
                        // })
                    })
                    .catch(e => {
                        console.log(e.response)
                        if(e.response.status === 401) {
                            console.log("salah login")
                            this.errors.push("Invalid login")
                        }else{
                            this.errors.push(e)
                        }
                    })
                    
                    /*
                    if(this.input.email == this.$parent.mockAccount.email && this.input.password == this.$parent.mockAccount.password) {
                        this.$emit("authenticated", true)
                        this.$router.replace({ name: "secure" })
                    } else {
                        this.result = "The email and / or password is incorrect"
                        console.log("The email and / or password is incorrect")
                    }*/
                } else {
                    this.result = "An email and password must be present"
                    console.log("An email and password must be present")
                }
            }
        }
    }
</script>

<style scoped>
    #login {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        padding: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/teacher/login.vue